export default "<loading></loading>\r\n<router-outlet></router-outlet>\r\n";